import React from "react";

const className = {
  Voice:
    "px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide bg-blue-100 text-blue-700",
  Written:
    "px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide bg-purple-100 text-purple-700",
  Both: "px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide bg-indigo-100 text-indigo-700",
};

const VersantTypeChip = ({ label }) => {
  return <span className="capitalize">{label}</span>;
};

export default VersantTypeChip;
